<template>
  <div :class="_.block">
    <div :class="_.content">
      <div :class="_.rule" v-html="theme.rule"></div>
      <div :class="_.data">
        <div :class="[_.item, _.left]">
          <p :class="_.text">剩余库存</p>
          <p :class="_.num">{{ goodsData.surplusStock }}</p>
        </div>
        <div :class="[_.item, _.right]">
          <p :class="_.text">销量</p>
          <p :class="_.num">{{ goodsData.sales }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    data() {
      return {
        goodsData: {},
      }
    },
    mounted() {
      this.$nextTick(() => {
        if (this.theme.commodityId) {
          this.getCommodityData()
        }
      })
    },
    methods: {
      jump() {
        this.$router.push({ path: '' })
      },
      async getCommodityData() {
        this.goodsData = await this.$dmbcApi.getCommodityData({
          commodityId: this.theme.commodityId,
        })
      },
    },
  })
</script>

<style lang="scss" module="_">
  // 之前单个img的写法可能受父级 flex: 1 影响图片在ios16以下版本会出问题
  .block {
    font-size: 0;

    .content {
      padding: var(--padding-top) var(--padding-right) var(--padding-bottom)
        var(--padding-left);
      .rule {
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.52) 0%,
          #ffffff 22%,
          #ffffff 100%
        );
        border-radius: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666660;
        line-height: 20px;
        text-align: justify;
        font-style: normal;
        padding: 12px;
      }
      .data {
        display: flex;
        margin-top: 9px;
        .item {
          padding: 12px;

          flex: 1;
          &:nth-child(1) {
            margin-right: 10px;
          }
          .text {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #666660;
            line-height: 20px;
            text-align: justify;
            font-style: normal;
          }
          .num {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: red;
          }
        }
        .left {
          background: var(--leftBackground);
          background-size: 100% 100%;
        }
        .right {
          background: var(--rightBackground);
          background-size: 100% 100%;
        }
      }
    }
  }
</style>
